require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')

# Load Css
require('../../../sass/web/html/_privacy.scss')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
]
angular.module 'gnp-app-policy', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')

    $routeProvider.when '/policy',
      controller: 'PolicyCtrl'
      template: '<div ng-include="templateUrl"></div>'
      title: '_PRIVACY_POLICY.TITLE'
  ]
  .controller 'PolicyCtrl', ['$scope', '$translate', ($scope, $translate) ->
    $scope.templateUrl = "templates/policy/index.#{$translate.use()}.html"
  ]




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/policy/policy-module.coffee